module.exports = __webpack_public_path__ + "static/media/note_list.82c34fe3.png";